import products from "@/http/requests/product";

export default {
    fetch({ commit }, { word = null, sortName = "name", orderBy = "ASC", erpId = null, id = null, page = 1, itemsPerPage = 4, hideNeedPrescription = false }) {
        return new Promise((resolve, reject) => {
            products.fetch(word, sortName, orderBy, erpId ,id, page, itemsPerPage, hideNeedPrescription)
            .then((response) => {
                const parsedData = response.data.data.products;

                commit('FETCH_PRODUCTS', parsedData);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        });
    },
    fetchAll({ commit }) {
        return new Promise((resolve, reject) => {
            products.fetch()
            .then((response) => {
                const parsedData = response.data.data.products;

                commit('SET_PRODUCTS', parsedData);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        });
    },
    update({ commit }, data) {
        return new Promise((resolve, reject) => {
            products.update(data)
            .then((response) => {
                console.log(response);
                const parsedData = response.data.data.updateProduct;

                commit('UPDATE_PRODUCTS', parsedData);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        });
    },
    create({ commit }, data) {
        return new Promise((resolve, reject) => {
            products.create(data)
            .then((response) => {
                const parsedData = response.data.data.createProduct;

                commit('CREATE_PRODUCTS', parsedData);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        });
    },
    delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            products.delete(id)
            .then((response) => {
                commit('DELETE_PRODUCTS', id);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        });
    }
}